import { useRef } from "react";
import { Drawer } from "antd";

import CheckIcon from '@mui/icons-material/Check';

import './MobileSheet.css';

/* Shared bottom sheet: handle, title and a list of options with a check
   on the selected one. Dismisses on mask tap or swipe down. Callers pass
   only the options; tapping one selects it and closes the sheet. */
const MobileSheet = ({ open, onClose, title, options, selected, onSelect }) => {
    const touchStartY = useRef(null);

    const onTouchEnd = (event) => {
        if (touchStartY.current === null) return;
        const dy = event.changedTouches[0].clientY - touchStartY.current;
        touchStartY.current = null;
        if (dy > 60) onClose();
    };

    const choose = (key) => {
        onSelect(key);
        onClose();
    };

    return (
        // zIndex above the fixed tab bar (1000) so the scrim covers it.
        <Drawer
            className="mobile-sheet"
            placement="bottom"
            height="auto"
            closable={false}
            title={null}
            zIndex={1001}
            visible={open}
            onClose={onClose}
            maskStyle={{ background: 'rgba(18,38,58,0.35)' }}
        >
            <div
                className="mobile-sheet-body"
                onTouchStart={event => { touchStartY.current = event.touches[0].clientY; }}
                onTouchEnd={onTouchEnd}
            >
                <span className="mobile-sheet-handle" />
                <div className="mobile-sheet-title">{title}</div>
                {options.map(({ key, label }) => (
                    <button
                        type="button"
                        key={key}
                        className={key === selected ? "mobile-sheet-option selected" : "mobile-sheet-option"}
                        onClick={() => choose(key)}
                    >
                        {label}
                        {key === selected && (
                            <span className="mobile-sheet-check">
                                <CheckIcon className="mobile-sheet-check-icon" />
                            </span>
                        )}
                    </button>
                ))}
            </div>
        </Drawer>
    );
};

export default MobileSheet;
